import React, { useState, useEffect, useRef }  from 'react';
import { GetRequest } from 'components/common/index.js';
import Constants from 'components/show_drawing/Constants.jsx';
import MyEventListener from 'components/common/MyEventListener.jsx'

const MyDownloadsButton = ( { id, drawing, asMenuItem = false, onSelect = () => {} } ) => {
  const [userDownloadCount, setUserDownloadCount] = useState(0)

  const getUserDownloadsCount = () => {
    if(drawing.image == undefined) { return; }

    GetRequest({
      url: `/${id}/user-downloads-btn-count`,
      callback: (data) => {
        setUserDownloadCount(() => data.count);
      }
    })
  }

  const handleShowDownloads = (e) => {
    e.preventDefault();
    setUpUserDownloadsBtn()

    if(userDownloadCount > 0) {
      window.drawing_id = id;
      fetchUserDownloads()
    }
  }

  // useEffect
  useEffect(getUserDownloadsCount, [id, drawing]);
  // useEffect

  MyEventListener( [
    {
      key: Constants.update_user_downloads_count_required,
      callback: getUserDownloadsCount,
    }]
  )

  if(userDownloadCount == 0) { return }

  if(asMenuItem) {
    return (
      <li role="none">
        <button type="button" role="menuitem" className="download-dropdown-item" onClick={(e) => { onSelect(e); handleShowDownloads(e); }}>
          <span className="icon-download download-dropdown-item-icon"></span> { t("models.my_downloads") }
          <span className="badge badge-light download-dropdown-item-badge" id="user_download_count_cont">
            {userDownloadCount}
          </span>
        </button>
      </li>
    )
  }

  return (
    <div className="inner my-downloads-container">
      <div className="child">
       <button className="btn btn-default btn-lg download-btn" onClick={handleShowDownloads}>
        <span className="icon-download"></span> &nbsp; { t("models.my_downloads") }  &nbsp;
        <span className="badge badge-light" id="user_download_count_cont" style={{"backgroundColor":"#eb5424", "fontWeight":"bold"}}>
        {userDownloadCount}
       </span>
       </button>
      </div>
    </div>
  )
}

export default MyDownloadsButton;